import TextCreate from 'core/display/simple/Text'
import { signal } from 'services/SignalsService'

export default class FreeBetText extends TextCreate{
  constructor(data) {
    super(data)
    this.text.visible = false

    signal.on('STATE:IN:FB-ADD', () => {
      this.text.visible = true
    })

    signal.on('STATE:OUT:FB-ADD',  () => {
      this.text.visible = false
    })

    signal.on('STATE:IN:FREE-BET',  () => {
      this.text.visible = true
    })

    signal.on('STATE:OUT:FREE-BET',  () => {
      this.text.visible = false
    })

    signal.on('FREEBET:Enabled',  (value) => {
      this.text.visible = value
    })
  }
}
